const salePrice = (sale) => {
  return (
    (sale.price.amount / Math.pow(10, sale.price.token_precision)).toFixed(2) +
    " " +
    sale.price.token_symbol
  )
}

export default salePrice
